import { Link } from 'react-router-dom';
import { FiInstagram, FiTwitter, FiFacebook, FiYoutube, FiMail, FiPhone, FiMapPin } from 'react-icons/fi';
import './Footer.css';

const SHOP_LINKS = [
  { label: 'All Products', to: '/products' },
  { label: 'Vendors', to: '/vendors' },
  { label: 'New Arrivals', to: '/products?sort=newest' },
  { label: 'Top Rated', to: '/products?sort=rating' },
  { label: 'Best Sellers', to: '/products?sort=popular' },
];

const SELL_LINKS = [
  { label: 'Become a Vendor', to: '/vendor/apply' },
  { label: 'Vendor Dashboard', to: '/vendor/dashboard' },
  { label: 'Seller Guidelines', to: '/seller-guidelines' },
  { label: 'Commission Rates', to: '/commission' },
  { label: 'Vendor Support', to: '/support' },
];

const ACCOUNT_LINKS = [
  { label: 'My Account', to: '/profile' },
  { label: 'My Orders', to: '/orders' },
  { label: 'Wishlist', to: '/wishlist' },
  { label: 'Shopping Cart', to: '/cart' },
  { label: 'Login / Register', to: '/login' },
];

const SOCIAL = [
  { icon: <FiInstagram />, label: 'Instagram', href: '#' },
  { icon: <FiTwitter />,   label: 'Twitter',   href: '#' },
  { icon: <FiFacebook />,  label: 'Facebook',  href: '#' },
  { icon: <FiYoutube />,   label: 'YouTube',   href: '#' },
];

export default function Footer() {
  return (
    <footer className="footer">
      <div className="footer-top container">
        <div className="footer-grid">
          {/* Brand */}
          <div className="footer-brand">
            <Link to="/" className="footer-logo">
              <img src="/fivora-logo.png" alt="Fivora" className="logo-img" />
              <span className="logo-text">Fivora</span>
            </Link>
            <p className="brand-desc">
              The modern multivendor marketplace — connecting thousands of buyers with trusted vendors worldwide.
            </p>
            <div className="contact-list">
              <a href="mailto:hello@fivora.com" className="contact-item">
                <FiMail size={14} /> hello@fivora.com
              </a>
              <a href="tel:+18005550000" className="contact-item">
                <FiPhone size={14} /> +1 800 555 0000
              </a>
              <span className="contact-item">
                <FiMapPin size={14} /> San Francisco, CA
              </span>
            </div>
            <div className="social-links">
              {SOCIAL.map(({ icon, label, href }) => (
                <a key={label} href={href} className="social-btn" aria-label={label} target="_blank" rel="noopener noreferrer">
                  {icon}
                </a>
              ))}
            </div>
          </div>

          {/* Shop */}
          <div className="footer-col">
            <h4 className="footer-heading">Shop</h4>
            <ul className="footer-links">
              {SHOP_LINKS.map(({ label, to }) => (
                <li key={label}><Link to={to} className="footer-link">{label}</Link></li>
              ))}
            </ul>
          </div>

          {/* Sell */}
          <div className="footer-col">
            <h4 className="footer-heading">Sell</h4>
            <ul className="footer-links">
              {SELL_LINKS.map(({ label, to }) => (
                <li key={label}><Link to={to} className="footer-link">{label}</Link></li>
              ))}
            </ul>
          </div>

          {/* Account */}
          <div className="footer-col">
            <h4 className="footer-heading">Account</h4>
            <ul className="footer-links">
              {ACCOUNT_LINKS.map(({ label, to }) => (
                <li key={label}><Link to={to} className="footer-link">{label}</Link></li>
              ))}
            </ul>
            <div className="app-badges">
              <span className="app-badge">📱 iOS App <span className="badge-soon">Soon</span></span>
              <span className="app-badge">🤖 Android App <span className="badge-soon">Soon</span></span>
            </div>
          </div>
        </div>
      </div>

      {/* Bottom bar */}
      <div className="footer-bottom">
        <div className="container footer-bottom-inner">
          <p className="copyright">
            &copy; {new Date().getFullYear()} Fivora. All rights reserved.
          </p>
          <div className="legal-links">
            <Link to="/privacy" className="legal-link">Privacy Policy</Link>
            <Link to="/terms" className="legal-link">Terms of Service</Link>
            <Link to="/cookies" className="legal-link">Cookies</Link>
          </div>
          <div className="payment-icons">
            {['Visa', 'MC', 'PayPal', 'Stripe'].map((p) => (
              <span key={p} className="payment-chip">{p}</span>
            ))}
          </div>
        </div>
      </div>
    </footer>
  );
}
